import { Modal } from 'react-bootstrap';

import { REQUIRE_TEAM_ON_UPLOAD } from '../../../../shared/featureFlags/flagNames';
import { useIsFeatureEnabled } from '../../../helpers/features/featureFlags';
import { userHasPermissionToViewAnyProject } from '../../../helpers/permissions';
import Button from '../../generic/Button/Button';
import { BUTTON_TYPE } from '../../generic/Button/button-constants';
import ButtonGroup from '../../generic/Button/ButtonGroup';
import SelectTeam from '../SelectTeam';
import type { Team } from '../../../../shared/model-typings';

import styles from './ModalTeamAssignment.module.less';

type ModalTeamAssignmentProps = {
  show: boolean;
  onHide: () => void;
  allTeams: Team[];
  selectedTeams: Team[];
  onTeamsSelected: (teams: Team[]) => void;
  onTeamsSelectionImport: () => void;
  hasNextStep?: boolean;
};

const ModalTeamAssignment = (props: ModalTeamAssignmentProps) => {
  const isTeamRequired = useIsFeatureEnabled(REQUIRE_TEAM_ON_UPLOAD);
  return (
    <Modal show={props.show} onHide={props.onHide}>
      <Modal.Header>
        <Modal.Title>
          Assign Project to Teams
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <SelectTeam
          allTeams={props.allTeams}
          selectedTeams={props.selectedTeams}
          onTeamsSelected={props.onTeamsSelected}
          isRequired={isTeamRequired}
        />
      </Modal.Body>
      <Modal.Footer className={styles.modalFooter}>
        <ButtonGroup>
          <Button type={BUTTON_TYPE.SECONDARY} onClick={props.onHide}>Cancel</Button>
          <Button
            type={BUTTON_TYPE.PRIMARY}
            onClick={props.onTeamsSelectionImport}
            isDisabled={(!userHasPermissionToViewAnyProject() || isTeamRequired) && props.selectedTeams.length === 0}
          >
            {props.hasNextStep ? 'Next' : 'Import Projects'}
          </Button>
        </ButtonGroup>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalTeamAssignment;
